import { createContext } from 'react';
export default createContext({});
//# sourceMappingURL=radioContext.js.map